import type { LifecycleEntitlement } from '@guard-dog/contracts';
import { describeEntitlement } from '../lib/entitlement';

export function LifecycleBanner({
  entitlement,
}: {
  entitlement: LifecycleEntitlement | null | undefined;
}) {
  const view = describeEntitlement(entitlement);
  return (
    <aside className={`lifecycle-banner lifecycle-${view.tone}`} aria-live="polite">
      <div>
        <span className="badge">{view.statusLabel}</span>
        <strong>{view.title}</strong>
      </div>
      <p>{view.body}</p>
      {view.restricted && (
        <a href="https://guarddog.cc/" target="_blank" rel="noreferrer">
          Contact us to upgrade
        </a>
      )}
    </aside>
  );
}
